<template>
  <p :class="className">
    {{ `${labelType} ${labelPeriod} ` }}
    <span class="text-bold" :class="$style.summString">{{ formatNumber(value) }} руб.</span>
  </p>
</template>

<script>
export default {
  name: "TextLabel",
  props: ["value", "type", "periodType"],
  computed: {
    labelType(){return this.staticText[this.type]},
    labelPeriod(){return this.staticText[this.periodType]},
    className(){return this.type === "balance" ? this.$style.balanceStringLabel : this.$style.overdraftStringLabel}
  },
  data() {
    return {
      staticText: {
        balance: "Баланс",
        overdraft: "Разрешенный овердрафт",
        onStartPreiod: "на начало отчетного периода:",
        onEndPeriod: "на конец отчетного периода:"
      }
    }
  }
}
</script>

<style lang="css" module>
.balanceStringLabel{
  margin-bottom: 3px;
}

.overdraftStringLabel{
  margin-top: 0px;
  margin-bottom: 0px;
}

.summString{
  font-size: 15px;
}
</style>